<template>
  <div class="cotainer card-item">
    <div class="title-box">
      <span class="title-text">科研情况</span>
      <span class="btn-action-group">
        <!-- v-if="oldInfos?.id && !isEdit"  -->
        <a-button type="primary" @click="addGains" class="btn-action"
          >新增</a-button
        >
        <!-- <a-button
          class="btn-action"
          type="primary"
          v-if="oldInfos?.id "
          @click="showevidence"
        >
        佐证材料</a-button> -->
        <!-- <a-button @click="importsj()" class="btn-action" v-if="oldInfos?.id && !isEdit">导入</a-button> -->
        <a-button class="btn-action" danger type="text" @click="batchDelete">
          批量移除</a-button
        >
      </span>
    </div>
    <div class="cotainerfottter">
      <a-table
        style="text-align: center"
        :locale="{
          emptyText: oldInfos?.id ? '暂无数据' : '填写基本信息之后才能添加内容',
        }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        @change="handleTableChange"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
        :scroll="{ y: 290 }"
        :row-selection="rowSelection"
      >
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template slot="sex" slot-scope="text, record, index">
          <span v-if="text == '1'">男</span>
          <span v-else>女</span>
        </template>
        <template slot="izResponse" slot-scope="text, record, index">
          <span v-if="text == '1'">是</span>
          <span v-else>否</span>
        </template>
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 50px"
        >
          <!--  -->
          <!-- <div
            class="flex align-items-center"
            style="cursor: pointer"
             v-if="(oldInfos && oldInfos.id && !isEdit)"
            @click="showevidence(record)"
          >
            <img class="img-box" src="../../assets/images/imgcl.png" alt="" />
            <span>佐证材料</span>
          </div> -->
          <!-- v-if="oldInfos?.id && !isEdit" -->
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="editInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="deleteInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
        </span>
      </a-table>
    </div>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>您确定要移除该条科研情况的数据吗?</p>
    </a-modal>
    <!-- 添加老师 -->
    <addScientificeRearch
      ref="addGain"
      @addGain="addGaincz"
    ></addScientificeRearch>
    <data-import ref="dataImport" @refreshData="addGain"></data-import>
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <evidencelist
          :title="title"
          :isEdit="isEdit"
          :dataid="sj.id"
          :id="id"
          @closePreview="showtable = false"
        >
        </evidencelist>
      </div>
    </div>
  </div>
</template>
    
<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import dataImport from "@/components/common/dataImport.vue";
import addScientificeRearch from "./addScientificeRearch.vue";
import evidencelist from "@/components/common/evidencelist";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "类型",
    dataIndex: "type",
    id: "type",
    align: "center",
    // width: 200,
  },
  {
    title: "项目名称/文章名称",
    dataIndex: "xmmc",
    id: "xmmc",
    align: "center",
    // width: 200,
  },
  {
    title: "立项单位/发表期刊",
    dataIndex: "lxdw",
    id: "lxdw",
    align: "center",
    // width: 200,
  },
  // {
  //   title: "年份",
  //   dataIndex: "year",
  //   id: "year",
  //   align: "center",
  //   width: 150,
  // },
  // {
  //   title: "数量",
  //   dataIndex: "num",
  //   id: "num",
  //   align: "center",
  //   width: 100,
  // },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 300,
    scopedSlots: { customRender: "action" },
  },
];
export default {
  data() {
    return {
      dataList: [],
      loading: false,
      showDeleteModel: false,
      deteleId: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      columns: columns,
      selectedRowKeys: [],
      isEdit: false,
      showtable: false,
      id: "",
      title: "",
      sj: {},
    };
  },
  props: {
    oldInfos: {
      type: Object,
    },
    isbj: {
      type: Boolean,
      defalt: true,
    },
  },
  components: {
    addScientificeRearch,
    dataImport,
    evidencelist,
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        // 其他 row-selection 的配置
      };
    },
  },
  watch: {
    "oldInfos.id": {
      handler(newValue, oldValue) {
        if (newValue != null) {
          if (
            this.$parent.editInfo &&
            this.$parent.editInfo?.type == "preview"
          ) {
            this.isEdit = true;
          }
          this.addGain();
        }
      },
      deep: true,
    },
    "oldInfos.sciencelist": {
      handler() {
        this.getData();
      },
      deep: true,
    },
    isbj: {
      handler(newValue, oldValue) {
        this.isEdit = newValue;
      },
      immediate: true,
    },
  },
  mounted() {
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
    this.getData();
  },
  methods: {
    showevidence(record) {
      this.title = "科研情况";
      this.id = this.oldInfos.id;
      this.sj = record;
      this.showtable = true;
    },
    importsj() {
      this.$refs.dataImport.init(
        "researchsituation",
        this.oldInfos,
        "科研情况"
      );
    },
    handleOk() {
      this.$message.success("移除成功");
      this.showDeleteModel = false;
      this.oldInfos.sciencelist = this.oldInfos.sciencelist.filter(
        (item) => String(item.id) !== String(this.deteleId)
      );
      sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
      this.getData();
      // deleteAction("/lxbase/lxResearchSituation/delete", {
      //   id: this.deteleId,
      //   applyId: this.oldInfos?.id
      // }).then((res) => {
      //   if (res.code == 200) {
      //     this.$message.success("移除成功");
      //     this.showDeleteModel = false;
      //     this.getData();
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // });
    },
    addGains() {
      this.$refs.addGain.init("add", this.oldInfos);
    },
    addGaincz(sj) {
      // console.log(sj);
      if (sj.type == "add") {
        this.pagination.current = 1;
        this.oldInfos.sciencelist.unshift({
          ...sj.record,
          id: "科研情况" + Date.now(),
        });
      } else {
        let index = this.oldInfos.sciencelist.findIndex(
          (item) => String(item.id) === String(sj.record.id)
        );
        // console.log(sj.record.id,this.oldInfos.sciencelist);
        if (index !== -1) {
          // 如果找到相同的 id，替换该对象
          this.oldInfos.sciencelist[index] = sj.record;
        }
      }
      sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
      // console.log(this.oldInfos.sciencelist);
      this.getData();
    },
    addGain() {
      //this.pagination.current = 1;
      this.getData();
    },
    // AI/历史数据若 id 重复或为 NaN，勾选一行会命中多行，批量移除会误删全部
    ensureUniqueScienceIds() {
      if (!this.oldInfos || this.oldInfos.id || !this.oldInfos.sciencelist) {
        return;
      }
      const list = this.oldInfos.sciencelist;
      const seen = new Set();
      let needFix = false;
      for (let i = 0; i < list.length; i++) {
        const id = list[i] && list[i].id;
        const key = id === undefined || id === null ? "" : String(id);
        if (!key || key === "NaN" || Number.isNaN(id) || seen.has(key)) {
          needFix = true;
          break;
        }
        seen.add(key);
      }
      if (needFix) {
        list.forEach((item, index) => {
          item.id = "科研情况" + index;
        });
        sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
      }
    },
    getData() {
      if (this.oldInfos?.id) {
        this.loading = true;
        let data = {
          applyType: 1,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/lxbase/lxResearchSituation/list", data).then((res) => {
          if (res.code === 200) {
            let data = res.result.records;
            if (data) {
              this.dataList = data;
              this.pagination.total = res.result.total;
            }
          }
          this.loading = false;
        });
      } else {
        if (
          this.oldInfos &&
          this.oldInfos.sciencelist &&
          this.oldInfos.sciencelist.length > 0
        ) {
          this.ensureUniqueScienceIds();
          this.pagination.total = this.oldInfos.sciencelist.length;
          const startIndex =
            (this.pagination.current - 1) * this.pagination.pageSize;
          const endIndex = startIndex + this.pagination.pageSize;
          let formatList = this.oldInfos.sciencelist.slice(
            startIndex,
            endIndex
          );
          if (formatList.length == 0 && this.pagination.current > 1) {
            this.pagination.current = this.pagination.current - 1;
            const startIndex =
              (this.pagination.current - 1) * this.pagination.pageSize;
            const endIndex = startIndex + this.pagination.pageSize;
            formatList = this.oldInfos.sciencelist.slice(startIndex, endIndex);
          }
          this.dataList = formatList;
        } else {
          this.dataList = [];
          this.pagination.total = 0;
          this.pagination.current = 1;
        }
      }
    },
    deleteInfo(row) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    editInfo(row) {
      this.$refs.addGain.init("edit", row);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    option(type) {
      if (type === 1) {
        this.$emit("upStep", this.dataList);
      } else {
        this.$emit("downStep", this.dataList);
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      if (!this.selectedRowKeys || this.selectedRowKeys.length === 0) {
        this.$message.warning("请选择要批量移除的科研情况");
        return;
      }
      if (!this.oldInfos || !Array.isArray(this.oldInfos.sciencelist)) {
        return;
      }
      const selectedSet = new Set(
        this.selectedRowKeys.map((key) => String(key))
      );
      // 只移除勾选行，保留未选中数据
      this.oldInfos.sciencelist = this.oldInfos.sciencelist.filter(
        (item) => !selectedSet.has(String(item.id))
      );
      sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
      this.selectedRowKeys = [];
      this.getData();
      this.$message.success("批量移除成功");
    },
  },
};
</script>
    
<style scoped="scoped" lang="scss">
.cotainer {
  &.card-item {
    background: #ffffff;
    box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
    padding: 37px 20px;
    box-sizing: border-box;
    margin-bottom: 24px;
    .title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 700;
      border-bottom: 1px solid #d9d9d9;
      .title-text {
        color: #2155b5;
        font-size: 20px;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        border-bottom: 3px solid #2155b5;
        padding: 0px 4px;
      }
    }
    .title-boxs {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 12px;
      font-size: 20px;
    }
    .btn-action {
      width: 100px;
      height: 30px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
  .cotainerhead {
    margin: 20px 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .add-btn {
      width: 100px;
      height: 30px;
      background: #2155b5;
      border-radius: 6px;
      font-weight: 400;
      color: #fff;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}
.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
</style>